import { Component, OnInit } from '@angular/core';
import { ServerDataSource, LocalDataSource } from 'ng2-smart-table';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { NewMenuComponent } from '../new-menu/new-menu.component';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { plainToClass } from 'class-transformer';
import { Menu } from '../../../shared/data/menu';
import swal from 'sweetalert2';

@Component({
  selector: 'ngx-liste-menu',
  templateUrl: './liste-menu.component.html',
  styleUrls: ['./liste-menu.component.scss']
})
export class ListeMenuComponent implements OnInit {
  constructor( private apiService:ApiService, private router:Router,private toastr:NbToastrService,private dialogService: NbDialogService,private sendeurService:EventSendeurService) { }

  ngOnInit() {
    this.getMenu();
    this.sendeurService.menu.subscribe(data =>{
      this.getMenu();
    })
  }

  
 
  source: LocalDataSource =  new LocalDataSource();
  settings = {

    hideSubHeader: false,
   
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: false,
      
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
  columns: {
    id: {
      title: 'ID',
      type: 'number',
      filter: false
    },
    nom: {
      title: 'Nom',
      type: 'string',
    },
   
    
  },
  pager : {
                perPage :10
  },
 
};



getMenu(){
  this.apiService.getAllMenuProvider().subscribe(data =>{
    
      this.source.load( plainToClass(Menu, data) );
      this.source.setSort([{ field: 'id', direction: 'desc' }]);

    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
    })

}


onCreate(event) {
  this.dialogService.open(NewMenuComponent);
}

select($event){
 
  let link = ['/menus/update', $event.data.id];
  this.router.navigate(link);
}

onDelete(event){

  // this.dialogService.open(DeleteMenuComponent,{context: { id: $event.data.id, nom:$event.data.nom}});
  // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
  const menu = plainToClass( Menu,  event.data as object);
    
  swal({
    title: 'Suppression Menu',
    text: 'Voulez - vous vraiment supprimer menu ' + menu.nom + ' ? Vous ne pourrez plus annuler cet opération',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Annuler',
    confirmButtonText: 'Confirmer',
    showLoaderOnConfirm: true,
    allowOutsideClick: false,
    preConfirm: () => {

      // this.dialogIsNotShow = true;

      return this.apiService.deleteMenuProvider(menu.id).subscribe(data =>{
        
        // console.log(data);
        this.source.remove(event.data);
       
      },(err) =>{
        this.toastr.danger("Echec de suppréssion ");
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }
  
        if(err.error.code ===500){
        
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
       }
      })

    },
  }).then((result) => {

    if (result.value) {


      this.toastr.success("Supprimé(e)", menu.nom);

    }

    // this.dialogIsNotShow = false;

  });


}


}
